import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { VehicleGroupSearchDto } from '../../vehicle-groups/dtos/vehicle-group-search.dto';

/**
 * Resolved related records for a vehicle category activity event, keyed by relation.
 */
export class VehicleCategoryActivityEventHydration {
  vehicleGroup?: ActivityFieldHydration<VehicleGroupSearchDto>;
  link?: ActivityLinkHydration;
}
